import { render } from "./EditRouteTarget.vue?vue&type=template&id=46033ad2"
import script from "./EditRouteTarget.vue?vue&type=script&lang=js"
export * from "./EditRouteTarget.vue?vue&type=script&lang=js"
script.render = render

export default script